




import { Vue } from 'vue-property-decorator';
import TooltipInfoDot from '../../components/tooltip-info-dot/tooltip-info-dot.vue';
import Component from 'vue-class-component';

@Component({
  inject: ['child'],
  components: { TooltipInfoDot },
  template: '',
})
export default class Tooltip extends Vue {}
